import React, { useEffect, useState } from "react";
import { getUrl } from "aws-amplify/storage";
import "./Avatar.css";

interface AvatarProps {
  avatarUrl?: string | null; // S3 key
  name?: string | null;
  className?: string;
  size?: "small" | "medium" | "large" | number;
}

const sizeMap = {
  small: 32,
  medium: 48,
  large: 80,
};

const Avatar: React.FC<AvatarProps> = ({
  avatarUrl,
  name,
  className = "",
  size = "medium",
}) => {
  const [signedUrl, setSignedUrl] = useState<string | null>(null);

  useEffect(() => {
    const fetchSignedUrl = async () => {
      if (!avatarUrl) {
        setSignedUrl(null);
        return;
      }

      try {
        const { url } = await getUrl({
          key: avatarUrl,
          options: { accessLevel: "guest" },
        });
        setSignedUrl(url.href);
      } catch (err) {
        console.error("Failed to fetch signed avatar URL:", err);
        setSignedUrl(null);
      }
    };

    fetchSignedUrl();
  }, [avatarUrl]);

  const dimension =
    typeof size === "number" ? size : sizeMap[size] || sizeMap.medium;

  const style: React.CSSProperties = {
    width: `${dimension}px`,
    height: `${dimension}px`,
    fontSize: `${dimension / 2.5}px`,
  };

  const fallbackInitial = name?.trim().charAt(0).toUpperCase() || "?";

  return signedUrl ? (
    <img
      src={signedUrl}
      alt="User Avatar"
      className={`user-avatar ${className}`}
      style={style}
    />
  ) : (
    <div className={`avatar-fallback ${className}`} style={style}>
      {fallbackInitial}
    </div>
  );
};

export default Avatar;
